module.exports = __webpack_public_path__ + "img/down_bg.59005d65.png";